import React, { useState } from "react";
import {
  DialogContent,
  Card,
  Button,
  DialogActions,
} from "@material-ui/core";
import Spin from "components/ui/Spin";
import { KisshtDialog } from "components/custom/KisshtDialog";
import { toastError, toastSuccess } from "shared/utils";
import { addDepositPayment, cashpaymentList } from "shared/api/deposit";
import CheckboxTable from "components/table/CheckboxTable";
import { useEffect } from "react";

var customer_payments = null;
const AddDepositPayment = (props) => {
  const { visible, handleClose, depositRef, deposit_by_ref } = props;
  const handleSubmitForm = async () => {
    if (customer_payments) {
      let param = {
        payment_reference_number: customer_payments,
      };
      addDepositPayment(param, depositRef).then((res) => {
        if (res && res.success) {
          handleClose(true);
          toastSuccess("Payment Added success");
        } else {
          toastError(res.message);
        }
      });
    }
  };
  const [cashPayments, setCashPayments] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [defaultSelected, setDefaultSelected] = useState([]);

  const fetchCashPayments = (_) => {
    customer_payments = null;
    setSpinning(true);
    cashpaymentList(deposit_by_ref)
      .then((res) => {
        if (res.success && res.data.cash_payments) {
          if (res.data.cash_payments.length) {
            setCashPayments(res.data.cash_payments);
          } else {
            setCashPayments([]);
          }
        }
        setSpinning(false);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  useEffect(() => {
    fetchCashPayments();
    // eslint-disable-next-line
  }, []);
  
  const checkPaymentHandle = (cashPayments)=>{
    return(
        cashPayments.length
        ? cashPayments.map(
            ({ payment_reference_number, amount }) => ({
              payment_reference_number,
              amount,
            })
          )
        : []
    )
  }

  return (
    <>
      <KisshtDialog
        title="Add Cash Deposit Payment"
        maxWidth={"sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Spin spinning={spinning}>
            <Card>
              {cashPayments && cashPayments.length > 0 ? (
                <div style={{ height: "400px", overflowY: "scroll" }}>
                  <CheckboxTable
                    defaultSelected={defaultSelected}
                    data={checkPaymentHandle(cashPayments)}
                    setAmount={(value, rows) => {
                      customer_payments = !rows.length
                        ? ""
                        : rows
                            .map((value) => value.payment_reference_number)
                            .join(",");
                      setDefaultSelected(rows);
                    }}
                    headCells={[
                      {
                        id: "calories",
                        numeric: true,
                        disablePadding: false,
                        label: "Calories",
                      },
                    ]}
                  />
                </div>
              ) : (
                <div className="py-8 text-center text-red-500">
                  No payment record found
                </div>
              )}
            </Card>
          </Spin>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            className="shadow-none common_kissht_btn"
            onClick={handleSubmitForm}
            disabled={!customer_payments}
          >
            Submit
          </Button>
          <Button
            onClick={() => handleClose(false)}
            variant="contained"
            className="shadow-none common_kissht_btn"
          >
            Close
          </Button>
        </DialogActions>
      </KisshtDialog>
    </>
  );
};

export default AddDepositPayment;
